
type LinearUnits = {
  npm: string | undefined; // N/m	
  lbfpin: string | undefined; // lbf/in
  npmm: string | undefined; // 	N/mm
}

type AngularUnits = {
  nmprad: string | undefined; // N.m/rad
  lbfinprad: string | undefined; // lbf.in/rad
}


export type StiffnessConversionState = {
  linear: LinearUnits;
  angular: AngularUnits;
};

// Reducer
type ConversionCategory = keyof Pick<
  StiffnessConversionState,
  'linear' | 'angular'
>;

type UpdateUnitAction = {
  type: 'update_unit';
  payload: {
    category: ConversionCategory;
    updatedUnits: Record<string, string>; // contains both the input and converted unit(s)
  };
};

type ResetCategoryAction = {
  type: 'reset_category';
  payload: {
    category: ConversionCategory;
  };
};

type ConversionAction =
  | UpdateUnitAction
  | ResetCategoryAction;


export const stiffnessConversionInitialState: StiffnessConversionState = {
  linear: { npm: undefined, lbfpin: undefined, npmm: undefined },
  angular: { nmprad: undefined, lbfinprad: undefined },
};


export const stiffnessConversionReducer = (
  state: StiffnessConversionState,
  action: ConversionAction
): StiffnessConversionState => {
  switch (action.type) {
    case 'update_unit': {
      const { category, updatedUnits } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          ...updatedUnits,
        },
      };
    }

    case 'reset_category': {
      const { category } = action.payload;
      const resetCategoryState = Object.keys(state[category]).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {} as Record<string, string | undefined>);

      return {
        ...state,
        [category]: resetCategoryState,
      };
    }

    default:
      return state;
  }
};

